var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"app-container tw-flex tw-flex-col"},[_c('global-alerts'),_c('div',{staticClass:"white tw-w-full"},[_c('router-view')],1),_c('generic-dialog')],1)}
var staticRenderFns = []

export { render, staticRenderFns }